import * as React from 'react';
import PropTypes from 'prop-types';
import FormItemWrapper from 'components/FormItemWrapper';

const InputComponent = React.forwardRef(({ color, ...props }, ref) => (
  <input
    {...props}
    ref={ref}
    className={`w-full input text-input filter drop-shadow-sm ${color === 'white' ? 'input--white' : 'input--zinc'}`}
  />
));

InputComponent.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.oneOf(['white', 'zinc']),
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  disabled: PropTypes.bool,
  required: PropTypes.bool
};

InputComponent.defaultProps = {
  label: null,
  className: '',
  color: 'white',
  error: null,
  disabled: false,
  required: false
};

const TextInput = React.forwardRef((props, ref) => (
  <FormItemWrapper
    ref={ref}
    InputComponent={InputComponent}
    {...props}
  />
));

export default TextInput;
